<!-- Toolbar: Edit-Toggle -->
<div class="ov-toolbar" *ngIf="canEdit">
  <button class="ov-toggle-btn" (click)="toggleEditMode()">
    <ion-icon [name]="isEditMode ? 'create' : 'eye-outline'"></ion-icon>
    {{ isEditMode ? 'Bearbeiten' : 'Ansicht' }}
  </button>
</div>

<!-- Produktliste -->
<div class="ov-list">

  <div class="ov-row" *ngFor="let product of computedProducts; trackBy: trackByProductId">

    <!-- Kopfzeile des Eintrags -->
    <div class="ov-row-head">

      <!-- Produktbild -->
      <div class="ov-thumb-wrap" (click)="openLightbox(product)">
        <ng-container *ngIf="imagesEnabled && product._thumbUrl">
          <img
            class="ov-thumb-img"
            [class.grayscale]="grayscaleImages"
            [src]="product._thumbUrl"
            alt=""
          />
          <!-- Farbtextur im unteren Fünftel: zeigt Objekt und Farbe in einem Bild -->
          <img
            *ngIf="product.colorcard && !product['_imgErr']"
            class="ov-thumb-color-strip"
            [src]="product.colorcard"
            alt=""
          />
        </ng-container>
        <div
          *ngIf="!imagesEnabled || !product._thumbUrl"
          class="ov-thumb-placeholder"
          [class.skeleton]="imagesEnabled && product._thumbLoading"
        >
          <ion-icon name="shirt-outline"></ion-icon>
        </div>
      </div>

      <div class="ov-row-identity">
        <span class="ov-name">{{ product.name }}</span>
        <span class="ov-name-de" *ngIf="product.nameDe">{{ product.nameDe }}</span>
        <span class="ov-meta">
          <span class="ov-tag">{{ product.model }}</span>
          <span class="ov-tag color ov-color-tag">
            <ng-container *ngIf="product.colorcard && !product['_imgErr']; else colorDotFallback">
              <img class="ov-color-dot-img" [src]="product.colorcard" (error)="product['_imgErr']=true" />
            </ng-container>
            <ng-template #colorDotFallback>
              <span class="ov-color-dot" [style.background]="colorHexFallback(product) || '#555'"></span>
            </ng-template>
            <span>{{ (product.colorname || product.color || '').toUpperCase() }}</span>
            <span class="ov-color-code" *ngIf="product.colorCode">#{{ product.colorCode }}</span>
            <ng-container *ngIf="product.colorDe">
              <span class="ov-color-de"> ({{ product.colorDe.toUpperCase() }})</span>
            </ng-container>
          </span>
          <app-karma-unavailable-badge
            *ngIf="isKarmaUnavailable(product)"
            [unavailable]="true"
            [since]="karmaUnavailableSince(product)"
            [model]="product.model"
            [colorname]="product.colorname || product.color"
            [currentInfo]="product.info"
            [orderId]="currentOrderId"
            (infoUpdated)="onKarmaInfoUpdated(product, $event)">
          </app-karma-unavailable-badge>
        </span>
      </div>
      <div class="ov-row-price">
        <span class="ov-price-total">{{ product._totalPrice | currency:'EUR' }}</span>
        <span class="ov-price-unit">{{ product.price | currency:'EUR' }} / Stk.</span>
      </div>
    </div>

    <!-- Größen -->
    <div class="ov-sizes">
      <ng-container *ngIf="isEditMode; else compactSizes">
        <div class="ov-size-edit" *ngFor="let size of product.sizes; trackBy: trackBySize">
          <span class="ov-size-label">{{ size.size }}</span>
          <button class="ov-qty-btn" (click)="decrementSize(product, size)" [disabled]="!canEdit || size.quantity <= 0">
            <ion-icon name="remove-outline"></ion-icon>
          </button>
          <span class="ov-qty-val" [class.zero]="size.quantity === 0">{{ size.quantity }}</span>
          <button class="ov-qty-btn" (click)="incrementSize(product, size)" [disabled]="!canEdit">
            <ion-icon name="add-outline"></ion-icon>
          </button>
        </div>
      </ng-container>
      <ng-template #compactSizes>
        <span
          *ngFor="let size of product.sizes; trackBy: trackBySize"
          class="ov-size-chip"
          [class.zero]="size.quantity === 0"
        >{{ size.size }}: {{ size.quantity }}</span>
      </ng-template>
    </div>

    <!-- Zusammenfassung + Aktionen -->
    <div class="ov-row-foot">
      <span class="ov-qty-total">{{ product._totalQuantity }} Stück</span>
      <span class="ov-info-text" *ngIf="product.info">{{ product.info }}</span>
      <span class="ov-admin-row" *ngIf="adminMode">
        <span class="ov-tag profit">+{{ product._profit | currency:'EUR' }}</span>
      </span>
      <div class="ov-actions" *ngIf="canEdit">
        <button class="ov-action-btn" (click)="editProduct(product)" title="Bearbeiten">
          <ion-icon name="create-outline"></ion-icon>
        </button>
        <button class="ov-action-btn" (click)="editNotes(product)" title="Notiz">
          <ion-icon name="document-text-outline"></ion-icon>
        </button>
        <button class="ov-action-btn danger" (click)="removeProduct(product)" title="Entfernen">
          <ion-icon name="trash-outline"></ion-icon>
        </button>
      </div>
    </div>

  </div>

</div>

<!-- Gesamtsumme -->
<div class="ov-summary">
  <div class="ov-summary-row">
    <span class="ov-summary-label">Artikel</span>
    <span class="ov-summary-value">{{ totals.totalQuantity }}</span>
  </div>
  <div class="ov-summary-divider"></div>
  <div class="ov-summary-row">
    <span class="ov-summary-label">Netto</span>
    <span class="ov-summary-value">{{ totalsTax.netPrice | currency:'EUR' }}</span>
  </div>
  <div class="ov-summary-row muted">
    <span class="ov-summary-label">MwSt. 19%</span>
    <span class="ov-summary-value">{{ totalsTax.taxAmount | currency:'EUR' }}</span>
  </div>
  <div class="ov-summary-row total">
    <span class="ov-summary-label">Brutto</span>
    <span class="ov-summary-value">{{ totalsTax.totalPrice | currency:'EUR' }}</span>
  </div>
  <ng-container *ngIf="adminMode">
    <div class="ov-summary-divider"></div>
    <div class="ov-summary-row muted">
      <span class="ov-summary-label">Kosten</span>
      <span class="ov-summary-value">{{ totals.totalCost | currency:'EUR' }}</span>
    </div>
    <div class="ov-summary-row profit">
      <span class="ov-summary-label">Profit</span>
      <span class="ov-summary-value">{{ totals.totalProfit | currency:'EUR' }}</span>
    </div>
  </ng-container>
</div>
